// extracted by mini-css-extract-plugin
export default {"pagination":"FW2FXgsj+E","item":"TFtyvef+zD","link":"_8HBv9k50FU","item-navigation-next":"MWOXnZbozC","itemNavigationNext":"MWOXnZbozC","item-navigation-prev":"mJxKKIry3C","itemNavigationPrev":"mJxKKIry3C","item-disabled":"srCe6bYF-1","itemDisabled":"srCe6bYF-1","item-active":"EEiIdQOvKI","itemActive":"EEiIdQOvKI","item-break":"kvPHjxXJvP","itemBreak":"kvPHjxXJvP"};
    if(module.hot) {
      // 1643570443897
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  